<template>
  <div class="token">
  </div>
</template>

<script>
export default {
  name: 'Token',

  metaInfo: {
    title: 'Redirecting...'
  },

  props: ['return'],

  async mounted () {
    try {
      await this.$cookies.set('token', this.$route.params.token)
      await this.$store.dispatch('syncUser')
      console.log(this.$route.query.next)
      this.$router.replace(this.$route.query.next || { name: 'Dashboard' })
    } catch (e) {
      this.$router.replace('/')
    }
  }
}
</script>
